import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Roles } from 'assets/icons/Roles.svg';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

import ActorOwnRoleSettingsView from './ActorOwnRoleSettingsView';
import CreateRoleSettingsCard from './CreateRoleSettingsCard';
import RolesList from './RolesList/RolesList';
import WorkspaceRoleCreateModal from '../WorkspaceRoleCreateModal/WorkspaceRoleCreateModal';
import WorkspaceRoleEditModal from '../WorkspaceRoleEditModal/WorkspaceRoleEditModal';

const WorkspaceRolesSetting = () => {
  const { t } = useTranslation();
  const { workspacePermissions } = useWorkspacesContext({ requireWorkspaceId: true });
  const { visible: isEditModalVisible } = useModal(WorkspaceRoleEditModal);
  const { visible: isCreateModalVisible } = useModal(WorkspaceRoleCreateModal);

  const canManageRoles = workspacePermissions.adjustRoles;

  const handleRoleClick = useCallback(
    (roleId: string) => {
      if (isEditModalVisible || isCreateModalVisible) return;
      NiceModal.show(WorkspaceRoleEditModal, { roleId });
    },
    [isEditModalVisible, isCreateModalVisible]
  );

  if (!canManageRoles) {
    return (
      <div className="flex flex-col space-y-4">
        <span className="text-xl font-semibold">{t('workspaces.roles')}</span>
        <ActorOwnRoleSettingsView />
      </div>
    );
  }

  return (
    <div className="flex flex-col space-y-4">
      <span className="text-xl font-semibold">{t('workspaces.roles')}</span>
      <div className="space-y-6">
        <CreateRoleSettingsCard />
        <SettingsCard>
          <SettingsCard.Header title={t('workspaces.workspace_roles')} icon={Roles} className="px-4" />
          <SettingsCard.Content className="!p-2">
            <RolesList onItemClick={handleRoleClick} />
          </SettingsCard.Content>
        </SettingsCard>
      </div>
    </div>
  );
};

export default WorkspaceRolesSetting;
